import { createContext } from 'react';


const CookieContext = createContext({
  cookie: {},
  saveCookie: () => { }
});

export default CookieContext;